import math from 'mathjs';
import {QListCountArray} from '../components/vectors/canvas';
import {DynamicQuestionVariable,VariableTypes,VariableMap,formatScientificNotation,AnswerFormulaMap, toScientificNotation}  from './types'
import {EvaluateOptions,QueryOptions } from "../common/functions"


function replaceAll(string, token, newtoken) {
    if(token!==newtoken)
    while(string.indexOf(token) > -1) {
        string = string.replace(token, newtoken);
    }
    return string;
}
function gcd(a, b) {
    if (b < 0.0000001) return a;                // Since there is a limited precision we need to limit the value.
  
    return gcd(b, Math.floor(a % b));           // Discard any fractions due to limitations in precision.
  };
function decimalToFraction(fraction){
    
 
      fraction = fraction.toFixed(2);
      //console.log('fraction',fraction);
      var len = fraction.toString().length - 2;
      
      var denominator = Math.pow(10, len);
      var numerator = fraction * denominator;
      
      var divisor = gcd(numerator, denominator);    
      
      numerator /= divisor;                         
      denominator /= divisor;                       
      if(denominator === 1){
        return Math.floor(numerator);
      }
      
        
        
     return  Math.floor(numerator) + '/' + Math.floor(denominator);
}

function toSigFig(x, n) {
    /**
     * https://github.com/corriander/python-sigfig/blob/dev/sigfig/sigfig.py
     * Convert a float, x, to a string with n significant figures.
     * This function returns a decimal string representation of a float
     * to a specified number of significant figures.
     * 
     * @example
     * string(9.80665, 3) // returns '9.81'
     * string(0.0120076, 3) // returns '0.0120'
     * string(100000, 5) // returns '100000'
     * 
     * Note: The last representation is, without context, ambiguous. This
     * is a good reason to use scientific notation, but it's not always
     * appropriate.
     * 
     * Note: Performing this operation as a set of string operations arguably
     * makes more sense than a mathematical operation conceptually. It's
     * the presentation of the number that is being changed here, not the
     * number itself (which is in turn only approximated by a float).
     */
    
    n = parseInt(n);
    x = parseFloat(x);
    
    if (n < 1) throw new Error("1+ significant digits required.");
    
    // retrieve the significand and exponent from the S.N. form
    // Using toExponential to get scientific notation with n-1 decimal places
    const parts = x.toExponential(n - 1).split('e');
    let s = parts[0];
    let e = parseInt(parts[1]);
    
    if (e === 0) {
        // Significand requires no adjustment
        return s;
    }
    
    s = s.replace('.', '');
    
    if (e < 0) {
        // Placeholder zeros need creating
        return `0.${'0'.repeat(Math.abs(e) - 1)}${s}`;
    } else {
        // Decimal place needs shifting
        s += '0'.repeat(Math.max(0, e - n + 1)); // s now has correct s.f.
        let i = e + 1;
        let sep = '';
        if (i < n) sep = '.';
        if (s[0] === '-') i += 1;
        return s.slice(0, i) + (s.slice(i) ? sep + s.slice(i) : '');
    }
}

function formatResult(variable,options){
    if(variable && options){
        let formattedValue = variable;
        if(options.type){
            switch(options.type){
                case VariableTypes.INT:                  
                    formattedValue = Math.round(variable);
                break;
                case VariableTypes.FLOAT:
                    if(options.sigFig){
                        //formattedValue =  MathParserUtil.ToPlainString(variable.toPrecision(parseInt(options.sigFig,10)));
                        formattedValue = toSigFig(variable, parseInt(options.sigFig,10));
                        // console.debug("formattedValue and formattedValue2>>>", formattedValue, formattedValue2)
                    }
                break;
                case VariableTypes.FRACTION:
                    formattedValue =   decimalToFraction(variable);
                break;
                case VariableTypes.SCIENTIFIC_NOTATION:
                    console.log('variable.toString()',variable.toString());
                    
                    /* formattedValue = formatScientificNotation(variable.toString(),{requiredWholeNumber:parseInt(options.decimalLimit,10),precision:parseInt(options.precision,10)}); */
                    formattedValue = toScientificNotation(variable, parseInt(options.decimalLimit));
                break;
                default:
                break;
            }


            return formattedValue;
        }

    }

    return variable;
    
}

/*

1) Parse Question and Detech the Variables in it
2) Show UI to set properties for each variable.
3) A ball travel [x] meters at a speed of [v] m/s. How long was the time of travel? 
*/
export default class MathParserUtil{

    static getFractionValue(num){
        return math.fraction(num)
    }
    static getFormulaFromText = (strQuestionText) => {
        let matchedStringArr =  strQuestionText.match(/{{(.*?)}}/g);
        if(matchedStringArr && matchedStringArr.length > 0){
            let matchedStr = matchedStringArr[0];
            matchedStr = matchedStr.replace("{{","");
            matchedStr = matchedStr.replace("}}","");
            return matchedStr;
        }
        return strQuestionText;
    }
    
    static computeFormula = (strQuestionText,variablesMap,displayOptions)=> {
     
        try{
            
       
        let formulaStringArray = MathParserUtil.getAnswerFormulasArrayFromText(strQuestionText);

        
        if(formulaStringArray && formulaStringArray.length > 0){
            formulaStringArray.forEach(formulaString => {
                let formulaWithValues =  MathParserUtil.setVariablesToText(formulaString,variablesMap);
                strQuestionText = strQuestionText.replace(formulaString,formatResult(math.eval(formulaWithValues.replace("{{","").replace("}}","")),displayOptions))
            });
        }

        }catch(e){
            console.error(e);
        }
        
        strQuestionText = strQuestionText.replace(/\^(-?\d+)\s*/g, '^{$1}'); // this is added to take all integers after ^ upto empty space
        return strQuestionText;
        
        /*let formulaString = MathParserUtil.getFormulaFromText(strQuestionText);
     
        if(formulaString && formulaString.length > 0){
            
           let formulaWithValues =  MathParserUtil.setVariablesToText(formulaString,variablesMap);
           //console.log('formulaWithValues',formulaWithValues);
           try{
             return strQuestionText.replace('{{'+formulaString+'}}',formatResult(math.eval(formulaWithValues),displayOptions));
           }catch(e){
               console.error("formatting error",e); 
                return strQuestionText;
           }
          
        }
        
        return strQuestionText;*/ 
    }

    static computeAnswer = (strQuestionText,variablesMap) => {
        let formulaString = MathParserUtil.getFormulaFromText(strQuestionText);
        if(formulaString && formulaString.length > 0){
            
            let formulaWithValues =  MathParserUtil.setVariablesToText(formulaString,variablesMap);
 
            console.log('math.eval(formulaWithValues)',math.eval(formulaWithValues));
            return math.eval(formulaWithValues);
         }

         return null;
    }

    static CheckAnswerVectorRange(answer_formula,currentVectorVariable){
        let answerRange = ""
        
        const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
        const FormulaOne =answer_formula?.formula;
        const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
        const QueryBuilderOption = answer_formula?.formulaqueryOption;
        const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
        const FormulaTwo = answer_formula?.formulaTwo;
        const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
        
        let formulaOneAnswerVariable = this.computeAnswer(FormulaOne, currentVectorVariable)
        let formulaOneOption = this.FindOptionsLabelByValue(EvaluateOptions,FormulaOneCondition)

        answerRange = formulaOneOption  + "  "+ formulaOneAnswerVariable 
        if(FormulaTwoSwitch) {
            let formulaTwoAnswerVariable = this.computeAnswer(FormulaTwo, currentVectorVariable)
            let formulaTwoOption = this.FindOptionsLabelByValue(EvaluateOptions,FormulaTwoCondition)
            let QueryBuilderOptionText = this.FindOptionsLabelByValue(QueryOptions,QueryBuilderOption)
            answerRange = answerRange + "  " +  QueryBuilderOptionText + "  "+  formulaTwoOption + "  "+  formulaTwoAnswerVariable
        }
        return answerRange
    }
    static FindOptionsLabelByValue = (optionsArray,value) => {
        const selectedOption = optionsArray?.find(option => option.value === value);
        return selectedOption ? selectedOption.label : "";
    };

    static EvaluateAnswerWithQueryOptions(Formula,currentVectorVariable,evaluateCondition,selectedVariable){
        let isCorrect  = false
        let answerVariable = this.computeAnswer(Formula, currentVectorVariable)
        //console.log("Vector answer Range----------_>--->select condition answer ",selectedVariable,evaluateCondition,answerVariable)
        if (evaluateCondition == 0) {
            //Equal to
            isCorrect = selectedVariable == answerVariable
        } else if (evaluateCondition == 1) {            //Greater than

            isCorrect = selectedVariable > answerVariable

        }else if (evaluateCondition == 2) {
             //Less than
             isCorrect = selectedVariable < answerVariable
            
        }else if (evaluateCondition == 3) {
             //Greater than or equal to
             isCorrect = selectedVariable >= answerVariable
            
        }else if (evaluateCondition == 4) {
             //less than or equal to
             isCorrect = selectedVariable <= answerVariable
       
        }
        return isCorrect
    }

    static getVariablesFromText = (strQuestionText,variablesMap) => {
        //
        if(variablesMap === undefined || variablesMap === null){
            variablesMap = MathParserUtil.createMap();
        }
        let variableArray = strQuestionText.match(/\[(.*?)\]/g);
        
        if(variableArray && variableArray.length > 0){
            variableArray.forEach(variable => {
                if(!variablesMap.has(variable)){
                    let variableObj = new DynamicQuestionVariable();
                    variableObj.name = variable;
                    variablesMap.set(variable,variableObj);
                }
                
            });

            
            for (var key of variablesMap.keys()) {
                if(!variableArray.includes(key))
                    variablesMap.delete(key);
            }

            return variablesMap;
        }
        
        
    }
    static CheckAnswerVectorRangeForScitificNotation(answer_formula,currentVectorVariable){
        let answerRange = {}
        const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
        const FormulaOne =answer_formula?.formula;
        const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : ""
        const QueryBuilderOption = answer_formula?.formulaqueryOption;
        const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
        const FormulaTwo = answer_formula?.formulaTwo;
        const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
        
        let formulaOneAnswerVariable = this.computeAnswer(FormulaOne, currentVectorVariable)
        const expValueFormulaOne = formulaOneAnswerVariable.toExponential(2);
        const sciValueFormulaOne = expValueFormulaOne.toString().replace('e','\\times 10^').replace('10^+','10^');
        const powerExpFormulaOne = sciValueFormulaOne.substr(sciValueFormulaOne.indexOf('10^'), sciValueFormulaOne.length);
        const powerDigitFormulaOne = sciValueFormulaOne.substr(sciValueFormulaOne.indexOf('10^')+3, sciValueFormulaOne.length);
        const replacedTextFormulaOne = `10^{${powerDigitFormulaOne}}`;
        const sciTextformulaOne = sciValueFormulaOne.replace(powerExpFormulaOne,replacedTextFormulaOne);
        let formulaOneOption = this.FindOptionsLabelByValue(EvaluateOptions,FormulaOneCondition)

        answerRange = formulaOneOption  + "  "+ sciTextformulaOne 
        if(FormulaTwoSwitch) {
            let formulaTwoAnswerVariable = this.computeAnswer(FormulaTwo, currentVectorVariable)
            const expValueFormulaTwo = formulaTwoAnswerVariable.toExponential(2);
            const sciValueFormulaTwo = expValueFormulaTwo.toString().replace('e','\\times 10^').replace('10^+','10^');
            const powerExpFormulaTwo = sciValueFormulaTwo.substr(sciValueFormulaTwo.indexOf('10^'), sciValueFormulaTwo.length);
            const powerDigitFormulaTwo = sciValueFormulaTwo.substr(sciValueFormulaTwo.indexOf('10^')+3, sciValueFormulaTwo.length);
            const replacedTextFormulaTwo = `10^{${powerDigitFormulaTwo}}`;
            const sciTextformulaTwo = sciValueFormulaTwo.replace(powerExpFormulaTwo,replacedTextFormulaTwo);
            let formulaTwoOption = this.FindOptionsLabelByValue(EvaluateOptions,FormulaTwoCondition)
            let QueryBuilderOptionText = this.FindOptionsLabelByValue(QueryOptions,QueryBuilderOption)
            answerRange = answerRange + "  " +  QueryBuilderOptionText + "  "+  formulaTwoOption + "  "+  sciTextformulaTwo
        }

        return answerRange
    }
    static shouldRandomize = (answerArr) => {
        if(answerArr.length > 1){
            let AnswerCountArr = QListCountArray(answerArr)
            let isSameAnswersPresent = AnswerCountArr.some((c)=> c>1) 
            return isSameAnswersPresent ? true:false;
        }else{
            return false;
        }
    }

    static stringToValueRPAnswer = (tempAnswerArrayList, tempVariableMap) => {
        let RPAnswerArr = [];
        for(let x=0;x<tempAnswerArrayList.length;x++){
          if(tempAnswerArrayList[x]?.answer_text && tempAnswerArrayList[x]?.answer_display_options){
            let answerText = MathParserUtil.computeFormula(
              tempAnswerArrayList[x].answer_text,
              tempVariableMap,
              tempAnswerArrayList[x].answer_display_options
            );
            RPAnswerArr.push(answerText?.replace(/(<([^>]+)>)/ig,"").trim())
          }
        }
        return RPAnswerArr;
    }

    static buildQuestionVariablesMap(variablesArray){
        let variablesMap  =  MathParserUtil.createMap();
        if(variablesArray){
            variablesArray.forEach(variable => {
                variablesMap.set(variable.name,variable);
         });
        }
      
        return variablesMap;
      }

    //Creates a Map and Adds custom helper functions before returing
    static createMap(){
        return new VariableMap();
    }

    static setVariablesToText = (strQuestionText,variablesMap,options) => {
        let localStrQuestionText = strQuestionText;
       
        
        if(variablesMap === undefined || variablesMap === null){
            //console.log('undefined');
            
           return strQuestionText;
        }

        
        for (var key of variablesMap.keys()) {
            if(options){
                if(options.formatValues === true){
                    localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).formattedValue);
                }

                localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).value);
            }else{
                if (key.includes("\\vec")) {
                    for (var key of variablesMap.keys()) {
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_x`, variablesMap.get(key).x);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_y`, variablesMap.get(key).y);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_z`, variablesMap.get(key).z);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_ang`, variablesMap.get(key).angle);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_mag`, variablesMap.get(key).mag);
                    }

                    localStrQuestionText = localStrQuestionText.replaceAll("[", "").replaceAll("]", "");
                } else {
                    localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).value);
                }
                
            }
            
            
        }
        
        return localStrQuestionText;
    }

    static mapToObj(inputMap) {
        let obj = {};
    
        inputMap.forEach(function(props, key){
            obj[key] = {...props,value:props.value.toString()}
        });
    
        return obj;
    }
    
    static ToPlainString = (num) => {
        return (''+num).replace(/(-?)(\d*)\.?(\d+)e([+-]\d+)/,
        function(a,b,c,d,e) {
            return e < 0
            ? b + '0.' + Array(1-e-c.length).join(0) + c + d
            : b + c + d + Array(e-d.length+1).join(0);
        });
    }

    static getAnswerFormulasArrayFromText = (strAnswerText) => {
        return strAnswerText.match(/\{{(.*?)\}}/g);
    }

    static splitAnswerTextFormulaToArray(strAnswerText){
        if(strAnswerText && strAnswerText.length > 0){
            return strAnswerText.split(/\{{(.*?)\}}/g);
        }

        return [strAnswerText];
    }

    static buildAnswerFormulasMap(answersFormulaArray){
        let variablesMap  = new AnswerFormulaMap();
        if(answersFormulaArray && answersFormulaArray.length > 0){
            console.log("answersFormulaArray",answersFormulaArray);
            
            answersFormulaArray.forEach(variable => {
                variablesMap.set(variable.text.trim(),variable);
         });
        }
      
        return variablesMap;
    }

    static isAnswerSelected(formulaMap,selectedAnswer){
        if(!selectedAnswer || !formulaMap){
            return false;
        }
        const answerFormulaTextArray = Array.from(formulaMap.keys()).map(text=>text.replace("{{","").replace("}}",""));
        for(let index=0;index<answerFormulaTextArray.length;index++){
            if((!selectedAnswer[answerFormulaTextArray[index]] && selectedAnswer[answerFormulaTextArray[index]] !== 0 && !isNaN(selectedAnswer[answerFormulaTextArray[index]])) || selectedAnswer[answerFormulaTextArray[index]]===""){
                return false;
            }
        }
        return true;
    }

    static decimalToFraction(decimal) {
        const tolerance = 1.0E-6;
    
        function gcd(a, b) {
            return b ? gcd(b, a % b) : a;
        }

        let numerator = 1;
        let denominator = 1;
        let fraction = numerator / denominator;
        
        while (Math.abs(fraction - decimal) > tolerance) {
            if (fraction < decimal) {
                numerator++;
            } else {
                denominator++;
                numerator = Math.round(decimal * denominator);
            }
            fraction = numerator / denominator;
        }
        
        const divisor = gcd(numerator, denominator);
        
        return `${numerator / divisor}/${denominator / divisor}`;
    }

    static convertToScientificForm(number) {
        let exponent = 0;
        
        while (number >= 1) {
            number /= 10;
            exponent++;
        }
        while (number < 0.1) {
            number *= 10;
            exponent--;
        }
        console.debug("Hello WORLD", `${number} x10^${exponent}`)
        return `${number}x10^${exponent}`
    }
}